export class ExcelLookupData {
  "S.no": string = null;
  Min: string = null;
  Max: string = null;
  SS: string = null;
}
